/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Metrics.Completion_
///   This is an auto-generated enumeration of the SWFC_Learning.Metrics.Completion domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum Completion_ {
   /// <summary>
   ///   Not Started (notst)
   /// </summary>
   NotStarted = 0,
   /// <summary>
   ///   Incomplete (inc)
   /// </summary>
   Incomplete = 1,
   /// <summary>
   ///   Completed (comp)
   /// </summary>
   Completed = 2
}

export const Completions: Completion[] = [
   {
      code: Completion_.NotStarted,
      literal: 'NotStarted',
      description: 'Not Started',
      shortDescription: 'notst',
      listPriority: 0,

      typeName: "Completion"
   },
   {
      code: Completion_.Incomplete,
      literal: 'Incomplete',
      description: 'Incomplete',
      shortDescription: 'inc',
      listPriority: 0,

      typeName: "Completion"
   },
   {
      code: Completion_.Completed,
      literal: 'Completed',
      description: 'Completed',
      shortDescription: 'comp',
      listPriority: 0,

      typeName: "Completion"
   }
]

export class Completion implements IDomainModel {
   code: Completion_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   typeName: string

   static toDomainModel(code: Completion_): Completion {
      return Completions.find(d => d.code === code)
   }
}
